import React, { useEffect } from "react"
import styled from "styled-components"
import { useFormContext } from "react-hook-form"
import PropTypes from "prop-types"
import { Label, Error } from "./input-v2.styled"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const CounterWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  padding: 4px 8px;
  width: 140px;
  justify-content: space-between;
  background: #fff;
  width: 100%;
`

const Button = styled.button`
  border: none;
  background: none;
  font-size: 20px;
  color: ${props => props.theme.secondary600};
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`

const Count = styled.span`
  color: ${props => props.theme.black};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`

const InputNumber = ({
  label,
  name,
  min = 1,
  max = 10,
  required = false,
  defaultValue = 1,
  validate,
  onValueChange,
}) => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext()

  useEffect(() => {
    setValue(name, defaultValue)
  }, [name, defaultValue, setValue])

  const count = watch(name) || defaultValue

  const handleDecrease = () => {
    if (count > min) {
      const newValue = count - 1
      setValue(name, newValue)
      onValueChange?.(newValue) // ✅ callback
    }
  }

  const handleIncrease = () => {
    if (count < max) {
      const newValue = count + 1
      setValue(name, newValue)
      onValueChange?.(newValue) // ✅ callback
    }
  }

  return (
    <Wrapper className="input-number">
      {label && <Label htmlFor={name}>{label}</Label>}
      <CounterWrapper>
        <Button onClick={handleDecrease} disabled={count <= min}>
          −
        </Button>
        <Count>{count}</Count>
        <Button onClick={handleIncrease} disabled={count >= max}>
          +
        </Button>
      </CounterWrapper>
      <input
        type="hidden"
        {...register(name, {
          required: required ? "This field is required" : false,
          validate: validate,
        })}
      />
      {errors[name] && <Error>{errors[name].message}</Error>}
    </Wrapper>
  )
}

InputNumber.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  required: PropTypes.bool,
  defaultValue: PropTypes.number,
  validate: PropTypes.func,
}

export default InputNumber
